/* main is the entry point for dssb aurelia enhancement*/

import {runStartHooks, runSystemHooks} from './bootstrap/app-hooks';
import {enhance} from './bootstrap/app-enhancer';
import {PLATFORM, Aurelia} from 'aurelia-framework';
import {HttpClient} from 'aurelia-http-client';
import Backend from 'i18next-xhr-backend';
import environments from './environments';
import {config as BluebirdConfig} from 'bluebird';
import {AureliaConfiguration} from 'aurelia-configuration';
import {I18N} from 'aurelia-i18n';
import './assets/legacy-assets-map';
import '../styles/styles.scss';
import './aurelia-api';
import 'intl';

BluebirdConfig({warnings: false, longStackTraces: false});

export async function configure(aurelia: Aurelia) {
  const container = aurelia.container;
  const httpClient: HttpClient = container.get(HttpClient);
  httpClient.configure(x => {
    x.withHeader('pragma', 'no-cache');
    x.withHeader('cache-control', 'no-cache');
  });
  aurelia.use
    .standardConfiguration()
    .feature(PLATFORM.moduleName('resources/index'))
    .plugin(PLATFORM.moduleName('aurelia-validation'))
    .plugin(PLATFORM.moduleName('aurelia-dialog'))
    .plugin(PLATFORM.moduleName('aurelia-property-injection'))
    .plugin(PLATFORM.moduleName('aurelia-configuration'), (config: AureliaConfiguration) => {
      config.setDirectory('assets/aurelia/config');
      config.setEnvironment('prod');
      config.setEnvironments(environments);
      config.setConfig('config.json?hash=' + BUILD_CONFIG_HASH);
    })
    .plugin(PLATFORM.moduleName('aurelia-i18n'), async (instance: I18N) => {
      instance.i18next.use(Backend);
      await instance.setup({
        backend: {
          loadPath: 'assets/aurelia/locales/{{lng}}/{{ns}}.json',
          queryStringParams: {hash: BUILD_LOCALES_HASH}
        },
        lng: PLATFORM.global.language,
        attributes: ['t', 'i18n'],
        fallbackLng: 'en',
        debug: false
      });
    });

  if (!BUILD_PRODUCTION) {
    aurelia.use.developmentLogging();
  }

  aurelia.use.singleton(HttpClient, httpClient as any);

  await aurelia.start().then(runSystemHooks).then(enhance).then(runStartHooks);
}
